module.exports = __webpack_public_path__ + "img/edition.9e7a17da.svg";